import React, { useState, useRef } from 'react';
import { ModernProductMappingList } from './ModernProductMappingList';
import { ModernProductMappingForm } from './ModernProductMappingForm';
import { ProductPlatformMapping } from '../services/grabService';

export const ModernProductMappingManagement: React.FC = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [editingMapping, setEditingMapping] =
    useState<ProductPlatformMapping | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateClick = () => {
    setEditingMapping(null);
    setFormOpen(true);
  };

  const handleEditClick = (mapping: ProductPlatformMapping) => {
    setEditingMapping(mapping);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingMapping(null);
  };

  const handleFormSave = () => {
    setFormOpen(false);
    setEditingMapping(null);
    setTimeout(() => {
      setRefreshKey((prev) => prev + 1);
    }, 1000);
  };

  return (
    <div className="container mx-auto p-6">
      <ModernProductMappingList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernProductMappingForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        mapping={editingMapping}
      />
    </div>
  );
};

